import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  Aangifte, BokkzAlgDataService,
  Box1BelastbareInkomstenUitEigenWoning,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overig-eigen-woning',
  templateUrl: './overig-eigen-woning.component.html',
  styleUrls: ['./overig-eigen-woning.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ]
})
export class OverigEigenWoningComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;
    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public extraInformatieEWS = {} as FormGroup

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.extraInformatieEWS = this.fb.group({
            belastDeelKapitaalverzekeringEigenWoningen: [null],
            renteInVoorgaandeJarenBetaaldVoorDitJaar: [null],
            renteInDitJaarVoorAndereJaren: [null]
        });
    }

    createExtraInformatieEWSFG(info?: Box1BelastbareInkomstenUitEigenWoning) {
        return {
            belastDeelKapitaalverzekeringEigenWoningen: info?.belastDeelKapitaalverzekeringEigenWoningen || undefined,
            renteInVoorgaandeJarenBetaaldVoorDitJaar: info?.belastDeelKapitaalverzekeringEigenWoningen || undefined,
            renteInDitJaarVoorAndereJaren: info?.belastDeelKapitaalverzekeringEigenWoningen || undefined
        } as Box1BelastbareInkomstenUitEigenWoning;
    }



    formStructure: any;

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.createExtraInformatieEWSFG()
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.extraInformatieEWS.dirty;
    }

    private updateForm(): void {
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        const kapverz = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning ? this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.belastDeelKapitaalverzekeringEigenWoningen : undefined;
        this.extraInformatieEWS.patchValue({belastDeelKapitaalverzekeringEigenWoningen: kapverz});
        const renteDitJaar = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning ? this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.renteInDitJaarVoorAndereJaren : undefined;
        this.extraInformatieEWS.patchValue({renteInDitJaarVoorAndereJaren: renteDitJaar});
        const renteVoorgaandJaar = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning ? this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.renteInVoorgaandeJarenBetaaldVoorDitJaar : undefined;
        this.extraInformatieEWS.patchValue({renteInVoorgaandeJarenBetaaldVoorDitJaar: renteVoorgaandJaar});

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            box1: {
                ...this.aangifte.box1,
                belastbareInkomstenUitEigenWoning: {
                    ...this.aangifte.box1?.belastbareInkomstenUitEigenWoning,
                    belastDeelKapitaalverzekeringEigenWoningen: this.extraInformatieEWS.value.belastDeelKapitaalverzekeringEigenWoningen,
                    renteInDitJaarVoorAndereJaren: this.extraInformatieEWS.value.renteInDitJaarVoorAndereJaren,
                    renteInVoorgaandeJarenBetaaldVoorDitJaar: this.extraInformatieEWS.value.renteInVoorgaandeJarenBetaaldVoorDitJaar,
                }
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        this.extraInformatieEWS.markAsDirty()
    }

}

